/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Button } from '@squiz/sds';
import React from 'react';
import { PreviewButtonProps } from './PreviewButton.props';

export const PreviewButton = ({
  dataTestId,
  disabled,
  icon,
  loading,
  name,
  onClick,
  onKeyDown,
}: PreviewButtonProps): JSX.Element => {
  return (
    <Button
      data-testid={dataTestId}
      disabled={disabled}
      icon={icon}
      isLoading={loading}
      onClick={() => onClick()}
      onKeyDown={onKeyDown}
      text={name}
    />
  );
};
